import React from 'react';
import i18n from 'i18next';

// components
import Modal from 'src/modules/shared/modal/components/modal';
import PointerModal from 'src/modules/shared/modal/components/pointerModal';
import SignupBox from 'src/modules/shared/modal/components/signup';
import LoginBox from 'src/modules/shared/modal/components/loginBox';
import ConfirmModal from './components/confirmModal';
import SecondPageSignupModal from './components/secondPageSignupModal';
import CreateAccountSocialSignupBox from 'src/modules/shared/modal/components/signup/createAccountSocial';
import LinkAccountSocialSignupBox from 'src/modules/shared/modal/components/signup/linkLoginToSocial';
import ResearchOptIn from 'src/modules/shared/modal/components/signup/researchOptIn';
import { setPendingVisitorReply } from 'src/modules/community/singlePost/actions/actions';
import classNames from 'classnames';

// utils
import config from 'config/config';
import actionTypes from './actionTypes';

export function showModal(modal) {
  return { type: actionTypes.MODAL_SET, modal };
}

export function closeModal() {
  return { type: actionTypes.MODAL_UNSET };
}

export function setModalAdvert(modal) {
  return { type: actionTypes.MODAL_ADVERT_SET, modal };
}

export function showSignupModal(signupContext, group, noLoginClose, defaultEmail, visitorReply, onSignupSuccess) {
  return (dispatch) => {
    dispatch(setPendingVisitorReply(visitorReply));
    return dispatch(
      showModal(
        <Modal
          noClose={noLoginClose}
          size="signup"
          textCentered={true}
        >
          <SignupBox
            defaultEmail={defaultEmail || ''}
            group={group || {}}
            signupContext={signupContext}
            visitorReply={visitorReply}
            onSignupSuccess={onSignupSuccess}
          />
        </Modal>,
      ),
    );
  };
}

export function showRouteChangeSignupModal() {
  return showModal(<SecondPageSignupModal />);
}

export function showLoginModal(noClose = false, visitorReply, onLoginSuccess) {
  return (dispatch) => {
    dispatch(setPendingVisitorReply(visitorReply));
    return dispatch(
      showModal(
        <Modal
          noClose={noClose}
          size="login"
          textCentered={true}
        >
          <LoginBox
            visitorReply={visitorReply}
            onLoginSuccess={onLoginSuccess}
          />
        </Modal>,
      ),
    );
  };
}

export function showInvalidLoginModal() {
  return showModal(
    <Modal size="sm">
      <div>Invalid login!</div>
    </Modal>,
  );
}

export function showCreateAccountSocialModal(authdata, signupContext, onSuccess) {
  // Explicit facebook DOB
  if (authdata.birthday) {
    const birthday = authdata.birthday.split('/');
    authdata.dateOfBirth = birthday[2] + '/' + birthday[0] + '/' + birthday[1];
  }
  const CreateAccountSocial = CreateAccountSocialSignupBox;
  return showModal(
    <Modal size="login">
      <CreateAccountSocial authdata={authdata} signupContext={signupContext} onSuccess={onSuccess} />
    </Modal>,
  );
}

export function showExistingLoginSocialModal(authdata, onSuccess) {
  return showModal(
    <Modal size="login" noClose={true}>
      <LinkAccountSocialSignupBox authdata={authdata} onSuccess={onSuccess} />
    </Modal>,
  );
}

export function showDFPModal(content) {
  return (dispatch, getState) => {
    // BB-1274: Prevent DFP popups from overwriting our Sign up Modal
    const { modal: { modal }} = getState();
    if (!!modal) return;

    return dispatch(setModalAdvert(
      <Modal>
        <div dangerouslySetInnerHTML={{ __html: content.src }} />
      </Modal>,
    ));
  };
}

export function showDiscoverNewTabModal({ title, onAccept, onCancel } = {}) {
  return showModal(
    <Modal
      accept="Continue"
      cancel="Cancel"
      title={title}
      onAccept={onAccept}
      onCancel={onCancel}
    >
      {i18n.t('You are about to navigate away from HealthUnlocked to a third party site.')}
    </Modal>,
  );
}

export function showResearchOptInModal({ onFinish } = {}) {
  return showModal(<ResearchOptIn onFinish={onFinish} />);
}

export function showHomeTopTip({ onClose }) {
  return (dispatch) => {
    const modalClassName = classNames({
      'tour-guide': true,
    });
    const contentClassName = classNames({
      'tour-content modal-content': true,
      'upper-arrow': true,
    });
    return dispatch(
      showModal(
        <PointerModal
          contentClassName={contentClassName}
          modalClassName={modalClassName}
          noClose={true}
          pointTo={{
            direction: 'upper-left',
            mobileDirection: 'upper-left',
          }}
        >
          <div className="content-pane">
            <h4>Top tip!</h4>
            <p className="main">Click the home icon to see your news feed and recommendations</p>
            <button
              className="btn btn-primary btn-full"
              type="button"
              onClick={() => {
                dispatch(closeModal());
                onClose();
              }}
            >
                Got it
            </button>
          </div>
        </PointerModal>,
      ),
    );
  };
}

const OPEN_SIGNUP_NORMALLY = '1';
const HIDE_MODAL_CLOSE_BUTTON = '0';

export function handleQueryParams(queryParams) {
  return (dispatch, getState) => {
    if (!queryParams) return;
    const { utm_source, popup, exit, branch } = queryParams;
    const { context: { currentUser } } = getState();
    if (!!currentUser) return;

    if (config.allowBranchTesting && branch) {
      window.HU_TEST_BRANCH = branch.toUpperCase();
    }

    if (utm_source === 'notification') {
      dispatch(showLoginModal(true));
    } else if (popup === OPEN_SIGNUP_NORMALLY) {
      const hideClose = exit === HIDE_MODAL_CLOSE_BUTTON;
      dispatch(showSignupModal(null, null, hideClose));
    }
    // TODO: add other modals from BG
  };
}

export function showConfirm(props) {
  return showModal(<ConfirmModal {...props} />);
}



// WEBPACK FOOTER //
// ./src/modules/shared/modal/actions.js